import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import LoginLeftSidePage from './LoginLeftSidePage';
import Const from '../util/Constants';
import LoginAPI from '../api/LoginAPI';
import Util from '../util/Util';
import config from '../config/config';
import ApiUiController from '../controller/ApiUiController';

import './Login.css';

class LoginPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = { isValidated: false, isAttempted: false, noAttemps: 0, inApiCall: false, 
      showPassword: false, username: '', password: '' };
  }

  componentDidMount() {
    const LoggedIn = reactLocalStorage.get(Const.LoggedIn);
    const Type = parseInt(reactLocalStorage.get(Const.Type));
    if (LoggedIn === Const.True && (Type === Const.Sales || Type === Const.Service)) {
      window.location.href = config.sales;
    } else if (LoggedIn === Const.True && Type === Const.RealEstate) {
      window.location.href = config.real_estate;
    } else if (LoggedIn === Const.True && Type === Const.HelpDesk) {
      window.location.href = config.help_desk;
    }
  }

  onKeyPress = event => event.key === 'Enter' ? this.onLoginClick() : null;
  onChangeUsername = event => this.setState({ ...this.state, username: event.target.value });
  onChangePassword = event => this.setState({ ...this.state, password: event.target.value });

  onLoginClick = () => {
    this.setState({ ...this.state, inApiCall: true });
    LoginAPI.login( this.state.username.trim(), this.state.password.trim(), this.onResponse, this.failure, this.props.logout);
  }

  failure = res => {
    Util.showNotification('Failure','Invalid usaername or password', 'danger');
    this.setState({ ...this.state, inApiCall: false });
  }

  onResponse = res => {
    reactLocalStorage.set(Const.LoggedIn, Const.True);
    reactLocalStorage.set(Const.Auth, res.auth);
    reactLocalStorage.set(Const.Type, res.type);
    
    if (res.type === Const.Sales || res.type === Const.Service) {
      window.location.href = config.sales + `/auth/${res.auth}`;
    } else if (res.type === Const.RealEstate) {
      window.location.href = config.real_estate + `/auth/${res.auth}`;
    } else if (res.type === Const.HelpDesk) {
      window.location.href = config.help_desk + `/auth/${res.auth}`;
    } else if (res.type === Const.Ticket) {
      window.location.href = config.ticket + `/auth/${res.auth}`;
    }
  }

  render() {
    return (
      <div className="view-container ">
        <section id="content" className="content_login" data-ng-view="" style={{ left: 0 }}>
          <div className="ng-scope">
            <div className="container-fluid">
              <div className="row">
                <LoginLeftSidePage />

                <div className="col-md-4 login-window" 
                  style={{ backgroundImage: "url(/images/admin-2.png)" }}>
                  <div className="login_panel">
                    <div id="helpTour pullRight">
                      <div className="appicon">
                        <a target="_blank" rel="noreferrer" href="tel:+919136390992">
                          <span className="support-div pullRight"> Support : +91 9136390992 </span>
                        </a>
                      </div>
                    </div>
                    <h2>Login</h2>
                    <ApiUiController inApiCall={this.state.inApiCall}>
                      <div className="login-form">
                        <section className="logo text-center">
                          <img className=" client_logo_login_logout"
                            src={process.env.PUBLIC_URL + "/images/logo.png"}
                            style={{ height: 36 + "px", width: 98 + "px" }} alt="Logo" />
                          <sup />
                        </section>
                        <div className="signin-body margin-top">
                          <div className="form-container">
                            <form className="form-horizontal ng-pristine ng-valid">
                            <fieldset>
                              <div className="form-group">
                                <div className="input-group input-group-lg">
                                  <span className="input-group-addon">
                                    <FaUser className="iconusers" />
                                  </span>
                                  <FormControl
                                    type="text"
                                    autoComplete="off"
                                    autoFocus="on"
                                    placeholder="Username"
                                    className="form-control"
                                    value={this.state.username}
                                    onKeyPress={this.onKeyPress}
                                    onChange={this.onChangeUsername} />
                                </div>
                              </div>
                              <div className="form-group">
                                <div className="input-group input-group-lg">
                                  <span className="input-group-addon">
                                  <FaLock className="iconusers" />
                                  </span>
                                  <FormControl
                                    type={this.state.showPassword ? "text" : "password"}
                                    autoComplete="off"
                                    autoFocus="on"
                                    placeholder="Password"
                                    className="form-control"
                                    value={this.state.password}
                                    onKeyPress={this.onKeyPress}
                                    onChange={this.onChangePassword} />
                                  <span className="input-group-addon" onClick={() => this.setState({ ...this.state, showPassword: !this.state.showPassword})}>
                                    { this.state.showPassword
                                      ? <FaEyeSlash className="iconusers" />
                                      : <FaEye className="iconusers" />
                                    }
                                  </span>
                                </div>
                              </div>
                              <Link to={"/reset-password"} className='d-block text-end mt-1 user-select-none'>
                                Forget password?
                              </Link>
                              <div className="form-group">
                                <Button
                                  className="btnsub btn btn-primary btn-lg btn-block"
                                  onClick={this.onLoginClick}>
                                  Login
                                </Button>
                              </div>
                            </fieldset>  
                            </form>
                          </div>
                        </div>
                      </div>
                    </ApiUiController>
                    <div className="form-group power-row">
                      <div className="">
                        <span className="copyright hidden-xs">© 2024 </span>
                        <a target="_blank" rel="noreferrer" href="http://www.orggencrm.com">
                          OrgGen Technologies
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default LoginPage;
